type FlowHandleSide = "left" | "right" | "top" | "bottom"

export type FlowHandleBox<P extends string = FlowHandleSide> = {
  x: number
  y: number
  width: number
  height: number
  position: P
}

/**
 * Точка, в которую xyflow сажает уже созданное ребро: внешний край ручки.
 * Центр кружка (`width / 2`) даёт другую кривую Безье — линия жеста дёргается на отпускании.
 */
export function flowEdgeHandlePoint<P extends string>(
  origin: { x: number; y: number },
  handle: FlowHandleBox<P>,
): { x: number; y: number; position: P } {
  const x = origin.x + handle.x
  const y = origin.y + handle.y
  const { width, height, position } = handle
  switch (position) {
    case "top":
      return { x: x + width / 2, y, position }
    case "right":
      return { x: x + width, y: y + height / 2, position }
    case "bottom":
      return { x: x + width / 2, y: y + height, position }
    default:
      return { x, y: y + height / 2, position }
  }
}
